import useSelected from "../useSelected";

export default ({ items, initial }) => {
	const computeInitial = initial ? initial.map(item => item.value) : [];

	const { selected, check, setSelected, reset, hasSelected } = useSelected(
		items.map(item => item.value),
		computeInitial
	);
	return { selected, check, setSelected, reset, isSelected: hasSelected };
};
